import React from 'react';
import { Link } from 'react-router-dom';

import logoBlack from "../img/logo/porcobrar_black.png";

/**
 * Componente logo de PorCobrar
 * 
 * @component
 */
const Logo = () => {
  return (
    <Link className='topbar__logo' to='/' style={{ backgroundImage: `url(${logoBlack})`}}/>
  )
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js